import Video from './video.js';

Video.init();